<template>

<component-module moduleName="pos_module">
    <template v-slot:programName>POS</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem, index) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
            <!-- <div class="menu-nav-extra">
                <router-link class="link" to="/legacy/possettingsmaintenance.php" key="sub-menu-item-legacy-1">Legacy POS Settings</router-link>
            </div> -->
            <router-link to="/help-center/articles/8" class="link menu-nav-extra">Help Center <i class="fa fa-chevron-right" /> POS</router-link>
        </div>
    </template>
</component-module>

</template>

<script>
import './pos.scss'
export default {
    created() {
        this.updateCustomModuleName('POS');
    },
    computed: {
        mainMenu() {
            if (!this.getModuleNavMenu) return {}
            return this.getModuleNavMenu
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'pos') {
                    return menuItem
                }
            }
        }
    }
}
</script>

<style>

</style>
